module.exports = __webpack_public_path__ + "img/orca.025d71cd.png";